/**
 * The backend answers `[{ error: "MyDjPlayerState_<playerId> is null", errorCode: 2 }]` while the
 * player has not published any state yet — it is offline, still starting, or its cache entry has
 * expired (see MyDjService.ProcessPhonePlayerRequest).
 *
 * It is a transient diagnostic, not a user-facing failure: the app just keeps polling until the
 * player reports in. Both transports must swallow it — the SignalR listener drops the whole
 * packet, and the HTTP (JSONP) transport used by the mobile builds must not turn it into an
 * "Unknown error MyDjPlayerState_… is null" popup.
 */
const PLAYER_STATE_PREFIX = 'MyDjPlayerState_';
const PLAYER_STATE_NULL_SUFFIX = ' is null';

/** True for the raw "player state is null" diagnostic text (also matches a wrapped payload). */
export function isPlayerStateNullMessage(message: unknown): boolean {
  if (typeof message !== 'string') {
    return false;
  }
  const trimmed = message.trim();
  return trimmed.includes(PLAYER_STATE_PREFIX) && trimmed.includes(PLAYER_STATE_NULL_SUFFIX);
}

/** True when a state packet carries nothing but that diagnostic. */
export function isPlayerStateNullState(state: any): boolean {
  if (!state || typeof state.error !== 'string') {
    return false;
  }
  const error = state.error.trim();
  return error.startsWith(PLAYER_STATE_PREFIX) && error.endsWith(PLAYER_STATE_NULL_SUFFIX);
}
